'use client'

import Link from 'next/link'
import s from './Clients.module.scss'
import { useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion'

type Props = { clients: any }

export default function ClientsComponent({ clients }: Props) {

    const containerRef = useRef<HTMLDivElement>(null)

    return (
        <div className={s.clients} ref={containerRef}>
            <div className={s.title}>
                <h2 id="about-clients-heading">{'Clients'}</h2>
            </div>
            <div className={s.contentContainer}>
                {clients?.map((client: any, index: number) => (
                    <div key={index} className={s.clientItem}>
                        <p translate='no'>
                            {client.website ? (
                                <Link href={client.website} target="_blank" rel="noopener noreferrer">
                                    {client.title}{client.location && `—${client.location}`}
                                </Link>
                            ) : (
                                <>{client.title}{client.location && `—${client.location}`}</>
                            )}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}